export default __webpack_public_path__ + "static/media/firoj.7d6062cd.jpg";